<template>
    <div class="freelancer-page" style="direction: rtl;">
        <!-- Header -->
        <div class="header d-flex align-items-center justify-content-start px-3 py-2">
            <router-link to="/profile"><i style="color: #fff;" class="fa-solid fa-arrow-right fa-xl"></i></router-link>
            <p style="font-weight: bold;" class="me-3 m-2">ترقية إلى مستقل</p>
        </div>

        <!-- Freelancer Information Form -->
        <div class="form-container px-3 py-2">
            <label style="color: #296080; font-weight: bold;" class="form-label">معلومات المستقل</label>
            <form @submit.prevent="submitForm">
                <!-- المدينة -->
                <label style="color: #296080;" class="form-label">المدينة</label>
                <div class="mb-3">
                    <select v-model="formData.cityid" class="form-select" required>
                        <option value="" disabled>اختر المدينة</option>
                        <option v-for="city in cities" :key="city.city_id" :value="city.city_id">
                            {{ city.city_name }}
                        </option>
                    </select>
                </div>

                <!-- الفئة -->
                <label style="color: #296080;" class="form-label">الفئة</label>
                <div class="mb-3">
                    <select v-model="formData.categoryid" class="form-select" required>
                        <option value="" disabled>اختر الفئة</option>
                        <option v-for="category in categories" :key="category.categories_id"
                            :value="category.categories_id">
                            {{ category.categories_name }}
                        </option>
                    </select>
                </div>

                <!-- السكن الحالي -->
                <label style="color: #296080;" class="form-label">الدولة الحالية</label>
                <div class="mb-3">
                    <input type="text" v-model="formData.currentcountry" class="form-control"
                        placeholder="الدولة الحالية" required />
                </div>

                <!-- وصف المهارات -->
                <label style="color: #296080;" class="form-label">الكفاءة</label>
                <div class="mb-3">
                    <textarea v-model="formData.competence" class="form-control" rows="3" placeholder="الكفاءة"
                        required></textarea>
                </div>

                <!-- وصف الشخصية -->
                <label style="color: #296080;" class="form-label">الشخصية</label>
                <div class="mb-3">
                    <textarea v-model="formData.personality" class="form-control" rows="3" placeholder="الشخصية"
                        required></textarea>
                </div>

                <!-- رقم الهاتف -->
                <label style="color: #296080;" class="form-label">رقم الهاتف</label>
                <div class="mb-3">
                    <input type="tel" v-model="formData.phone" class="form-control" placeholder="رقم الهاتف" required />
                </div>

                <!-- زر الترقية -->
                <button type="submit" class="btn btn-primary w-100" :disabled="loading">
                    {{ loading ? "جاري الإرسال..." : "ترقية إلى مستقل" }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "UpgradeToFreelancer",
    data() {
        return {
            cities: [],
            categories: [],
            loading: false,
            formData: {
                usersid: "",
                cityid: "",
                categoryid: "",
                currentcountry: "",
                phone: "",
                competence: "",
                personality: "",
            },
        };
    },
    methods: {
        fetchCities() {
            fetch("https://zadcodeonline.com/ahmad/etqan/backEnd/city/view.php")
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === "success") {
                        this.cities = data.data;
                    }
                })
                .catch((error) => console.error("Error fetching cities:", error));
        },
        fetchCategories() {
            fetch("https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view.php")
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === "success") {
                        this.categories = data.data;
                    }
                })
                .catch((error) => console.error("Error fetching categories:", error));
        },
        async submitForm() {
            this.loading = true; // تفعيل مؤشر التحميل
            try {
                const formData = new FormData();

                // إضافة البيانات إلى FormData بنفس الأسماء التي يتوقعها الخادم
                formData.append('usersid', this.formData.usersid); // جلب userId من localStorage
                formData.append('cityid', this.formData.cityid);
                formData.append('categoryid', this.formData.categoryid);
                formData.append('currentcountry', this.formData.currentcountry);
                formData.append('phone', this.formData.phone);
                formData.append('competence', this.formData.competence);
                formData.append('personality', this.formData.personality);

                console.log("Form data:", this.formData);
                // إرسال البيانات باستخدام axios
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/freelance/add.php',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                console.log("Data submitted successfully:", response.data);
                if (response.data.status === 'success') {
                    this.$router.push('/profile');
                } else {
                    alert("حدث خطأ: " + response.data.message);
                }
            } catch (error) {
                console.error("There was an error submitting the form:", error);
                alert("حدث خطأ أثناء إرسال البيانات!");
            } finally {
                this.loading = false; // إيقاف مؤشر التحميل
            }
        },
    },
    mounted() {
        const userId = localStorage.getItem("userId");
        this.formData.usersid = userId ? parseInt(userId, 10) : null;
        this.fetchCities();
        this.fetchCategories();
    },
};
</script>

<style scoped>
.freelancer-page {
    height: 100vh;
    background-color: #ffffff;
}

.header {
    background-color: #296080;
    color: white;
}

.form-container {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
}

input,
textarea,
select {
    border-radius: 10px;
}
</style>
